// Components - UI
import Scroller from '@/components/ui/Scroller/Scroller.vue';
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import UserLevelSelector from '@/components/ui/UserLevelSelector/UserLevelSelector.vue';

// Services
import UsersService from '@/services/UsersService.js';
import RetailersService from '@/services/RetailersService.js';
import MultisitesService from '@/services/MultiSitesService.js';
import ResetPasswordService from '@/services/ResetPasswordService.js';
import ServiceProvidersService from '@/services/ServiceProvidersService.js';

// EventBus
import { EventBus } from '@/EventBus.js';

// Vendor
import Validator from 'validator';
import moment from 'moment';

export default {

  name: 'account',

  components: {
    Scroller,
    UserIcon,
    UserLevelSelector
  },

  data: function() {
    return {
      retailer: null,
      multisiteRetailer: null,
      serviceProvider: null,

      // Edit company info mode
      editCompanyModeActive: false,
      editCompanyRecord: null,

      // Add user mode
      addUserModeActive: false,
      addUserRecord: null,

      // Edit user mode
      editUserModeActive: false,
      editUserRecord: null
    }
  },

  created: function() {
    this.bindEvents();
    this.init();
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  computed: {
    getActiveSubscriptionRetailer: function() {
      let activeSubscriptions = this.retailer.subscriptions.filter((s) => {
        let subStartDate = moment(s.createdAt);
        let subEndDate = moment(s.createdAt).add(12, 'months');

        if(subEndDate.isAfter(moment())) {
          return true;
        }
      });

      if(activeSubscriptions.length > 0) {
        return activeSubscriptions[0];
      }

      return null;
    },

    getActiveSubscriptionServiceProvider: function() {
      let activeSubscriptions = this.serviceProvider.subscriptions.filter((s) => {
        let subStartDate = moment(s.createdAt);
        let subEndDate = moment(s.createdAt).add(12, 'months');

        if(subEndDate.isAfter(moment())) {
          return true;
        }
      });

      if(activeSubscriptions.length > 0) {
        return activeSubscriptions[0];
      }

      return null;
    }
  },

  methods: {
    bindEvents: function() {
      // Listen for User Delete Events
      EventBus.$on('userDeleteYesClicked', (data) => {
        UsersService.deleteById(data.userId)
        .then((res) => {
          this.init();
          EventBus.dispatchDialogEvent('Success! The user was deleted successfully.');
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst deleting the user, please try again.');
        });
      });
    },

    init: function() {
      let id = localStorage.getItem('parentId');  // Is the id of the associated entity of the logged in user (retailer, multi-site-retailer, service-provider)

      if(localStorage.getItem('userGroup') == 'retailers') {
        RetailersService.getById(id)
          .then((res) => {
            res.data.team = res.data.team.sort((a, b) => {
              if(a.fullName < b.fullName) {
                return -1;
              }
              else if(a.fullName > b.fullName) {
                return 1;
              }

              return 0;
            });

            this.retailer = res.data
          })
          .catch((err) => {

          });
      }
      else if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        MultisitesService.getById(id)
          .then((res) => {
            res.data.team = res.data.team.sort((a, b) => {
              if(a.fullName < b.fullName) {
                return -1;
              }
              else if(a.fullName > b.fullName) {
                return 1;
              }

              return 0;
            });

            this.multisiteRetailer = res.data;
          })
          .catch((err) => {

          });
      }
      else if(localStorage.getItem('userGroup') == 'service-providers') {
        ServiceProvidersService.getById(id)
          .then((res) => {
            res.data.team = res.data.team.sort((a, b) => {
              if(a.fullName < b.fullName) {
                return -1;
              }
              else if(a.fullName > b.fullName) {
                return 1;
              }

              return 0;
            });

            this.serviceProvider = res.data;
          })
          .catch((err) => {

          });
      }
    },

    activateEditCompanyMode: function() {
      if(localStorage.getItem('userGroup') == 'retailers') {
        this.editCompanyRecord = JSON.parse(JSON.stringify(this.retailer)); // Cheat to clone object
      }
      else if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        this.editCompanyRecord = JSON.parse(JSON.stringify(this.multisiteRetailer)); // Cheat to clone object
      }
      else if(localStorage.getItem('userGroup') == 'service-providers') {
        this.editCompanyRecord = JSON.parse(JSON.stringify(this.serviceProvider)); // Cheat to clone object
      }

      this.editCompanyModeActive = true;
    },

    cancelEditCompanyMode: function() {
      this.editCompanyModeActive = false;
    },

    saveEditCompanyMode: function() {
      if(localStorage.getItem('userGroup') == 'retailers') {
        let updateData = {
          name: this.editCompanyRecord.name,
          contactName: this.editCompanyRecord.contactName,
          contactTelephone: this.editCompanyRecord.contactTelephone,
          contactEmail: this.editCompanyRecord.contactEmail,
          address: this.editCompanyRecord.address,
          city: this.editCompanyRecord.city,
          postcode: this.editCompanyRecord.postcode
        };

        RetailersService.replace(this.editCompanyRecord.id, updateData)
          .then((res) => {
            this.retailer = this.editCompanyRecord;
            this.editCompanyModeActive = false;
            EventBus.dispatchDialogEvent('Success! The company information was updated successfully.');
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst saving the company information, please try again.');
          });
      }
      else if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        let updateData = {
          name: this.editCompanyRecord.name,
          contactName: this.editCompanyRecord.contactName,
          contactTelephone: this.editCompanyRecord.contactTelephone,
          contactEmail: this.editCompanyRecord.contactEmail,
          contactAddress: this.editCompanyRecord.contactAddress,
          contactCity: this.editCompanyRecord.contactCity,
          contactPostcode: this.editCompanyRecord.contactPostcode
        };

        MultisitesService.replace(this.editCompanyRecord.id, updateData)
          .then((res) => {
            this.multisiteRetailer = this.editCompanyRecord;
            this.editCompanyModeActive = false;
            EventBus.dispatchDialogEvent('Success! The company information was updated successfully.');
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst saving the company information, please try again.');
          });
      }
      else if(localStorage.getItem('userGroup') == 'service-providers') {
        let updateData = {
          name: this.editCompanyRecord.name,
          contactName: this.editCompanyRecord.contactName,
          adminContactTelephone: this.editCompanyRecord.adminContactTelephone,
          adminContactEmail: this.editCompanyRecord.adminContactEmail,
          adminAddress: this.editCompanyRecord.adminAddress,
          adminCity: this.editCompanyRecord.adminCity,
          adminPostcode: this.editCompanyRecord.adminPostcode
        };

        ServiceProvidersService.replace(this.editCompanyRecord.id, updateData)
          .then((res) => {
            this.serviceProvider = this.editCompanyRecord;
            this.editCompanyModeActive = false;
            EventBus.dispatchDialogEvent('Success! The company information was updated successfully.');
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst saving the company information, please try again.');
          });
      }

    },

    // Add User mode
    // ------------------------------
    activateAddUserMode: function() {
      this.addUserRecord = {
        fullName: null,
        emailAddress: null,
        permissionsGroup: null
      };

      this.addUserModeActive = true;
    },

    cancelAddUserMode: function() {
      this.addUserModeActive = false;
    },

    saveAddUserMode: function() {
      if(this.validateUserRow(this.addUserRecord)) {
        if(Validator.isEmail(this.addUserRecord.emailAddress)) {
          if(localStorage.getItem('userGroup') == 'retailers') {
            this.addUserRecord.retailer = localStorage.getItem('parentId');
          }
          else if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
            this.addUserRecord.multiSite = localStorage.getItem('parentId');
          }
          else if(localStorage.getItem('userGroup') == 'service-providers') {
            this.addUserRecord.serviceProvider = localStorage.getItem('parentId');
          }

          UsersService.createOne(this.addUserRecord)
            .then((res) => {
              ResetPasswordService.resetPassword(this.addUserRecord.emailAddress)
                .then((res) => {
                  this.addUserModeActive = false;
                  this.init();
                  EventBus.dispatchDialogEvent('Success! The user was created successfully. They will recieve an email allowing them to set their password.');
                })
                .catch((err) => {
                  EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst creating the user, please try again.');
                });
            })
            .catch((err) => {
              EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst creating the user, please try again.');
            });
        }
        else {
          EventBus.dispatchErrorEvent('Sorry, the email address provided was not valid. Please check and try again.');
        }
      }
      else {
        EventBus.dispatchErrorEvent('Please ensure that all user fields are completed correctly before saving.');
      }
    },


    // Edit User mode
    // -------------------------
    activateEditUserMode: function(user) {
      this.editUserRecord = JSON.parse(JSON.stringify(user)); // Cheat deep clone object
      this.editUserModeActive = true;
    },

    cancelEditUserMode: function() {
      this.editUserRecord = null;
      this.editUserModeActive = false;
    },

    saveEditUserMode: function() {
      if(this.validateUserRow(this.editUserRecord)) {
        if(Validator.isEmail(this.editUserRecord.emailAddress)) {
          UsersService.replace(this.editUserRecord.id, this.editUserRecord)
            .then((res) => {
              this.editUserRecord = null;
              this.editUserModeActive = false;
              this.init();

              EventBus.dispatchDialogEvent('Success! The user was updated successfully. They will recieve an email allowing them to set their password.');
            })
            .catch((err) => {
              EventBus.dispatchErrorEvent('Whoops! Something went wrong whilst creating the user, please try again.');
            });
        }
        else {
          EventBus.dispatchErrorEvent('Sorry, the email address provided was not valid. Please check and try again.');
        }
      }
      else {
        EventBus.dispatchErrorEvent('Please ensure that all user fields are completed correctly before saving.');
      }
    },

    deleteExistingUser: function(userId) {
      let message = 'Are you sure you want to delete this user?';

      let options = [
        {
          optionText:'Yes',
          optionEvent:'userDeleteYesClicked',
          optionData: {
            userId: userId
          }
        },
        {
          optionText:'No',
          optionEvent:'userDeleteNoClicked',
          optionData: null
        }
      ];

      EventBus.dispatchDialogEvent(message, options);
    },

    // Shared Between Add and Edit Modes
    validateUserRow: function(userRow) {
      if(userRow.fullName == null || userRow.emailAddress == null || userRow.permissionsGroup == null) {
        return false;
      }

      if (userRow.fullName.length == 0 || userRow.emailAddress.length == 0) {
        return false;
      }

      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Account/Account.js